import React from 'react'
import { useParams } from 'react-router-dom'
import EmployeeDetail from 'src/containers/Employees/EmployeeDetail'

const employeeDataFields = [
	{ value: 'name', label: 'Name' },
	{ value: 'email', label: 'Email' },
	{ value: 'phone', label: 'Phone' },
	// { value: 'gender', label: 'Gender' },
	{ value: 'birthday', label: 'Birthday' },
	{ value: 'role', label: 'Account type' },
	{ value: 'employee_roles', label: 'Permissions', width: 100 },
	{ value: 'status', label: 'Status' },
	{ value: 'created_at', label: 'Created at' },
	{ value: 'updated_at', label: 'Updated at' },
	// { value: 'last_login_at', label: 'Last login at' },
	// { value: 'blocked_at', label: 'Blocked at' },
	// { value: 'blocked_reason', label: 'Blocked reason' },
	// { value: 'blocked_type', label: 'Blocked type' },
]

function EmployeeDetailPage() {
	const params = useParams()
	const { id } = params
	return (
		<EmployeeDetail
			id={id}
			fields={employeeDataFields}
			label="Employees"
			goBack="/employees"
		/>
	)
}

export default React.memo(EmployeeDetailPage)
